import React from 'react';
import { Images } from '../../../utils/imageConstants';
import { PLATFORM_BENEFITS } from '../constants/platformBenefits';
import { FaThLarge, FaMobileAlt, FaTrophy, FaUserFriends } from 'react-icons/fa';
import './PlatformBenefitsSection.scss';

const ICON_MAP: Record<string, React.ReactNode> = {
  grid: <FaThLarge size={28} />,
  phone: <FaMobileAlt size={28} />,
  trophy: <FaTrophy size={28} />,
  users: <FaUserFriends size={28} />,
};

const PlatformBenefitsSection: React.FC = () => {
  return (
    <section className="logged-home-platform-benefits" style={{ ['--platform-bg' as string]: `url(${Images.platform_bg})` }}>
      <div className="logged-home-platform-benefits-inner">
        <div className="logged-home-platform-benefits-badge">Platform Benefits</div>
        <div className="logged-home-platform-benefits-content">
          <h2 className="logged-home-platform-benefits-title">Why Use CricCenter</h2>
          <p className="logged-home-platform-benefits-subtitle">
            Everything you need to organize, play, and enjoy cricket in one powerful platform.
          </p>
        </div>
        <div className="logged-home-platform-benefits-grid">
          {PLATFORM_BENEFITS.map((benefit) => (
            <div key={benefit.id} className="logged-home-platform-benefit-card">
              <div className="logged-home-platform-benefit-icon">
                {ICON_MAP[benefit.icon] ?? <FaThLarge size={38} />}
              </div>
              <div className="logged-home-platform-benefit-content">
                <h3 className="logged-home-platform-benefit-title">{benefit.title}</h3>
                <p className="logged-home-platform-benefit-desc">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformBenefitsSection;
